import { render } from "./ProductCart.vue?vue&type=template&id=1b62ae1a&scoped=true"
import script from "./ProductCart.vue?vue&type=script&lang=js"
export * from "./ProductCart.vue?vue&type=script&lang=js"

import "./ProductCart.vue?vue&type=style&index=0&id=1b62ae1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b62ae1a"]])

export default __exports__